import Greeting from "../../components/greetings/Greeting";
import ReviewsCarousel from "../../components/reviews/ReviewsCarousel";
import ResponsiveCarousel from "../../components/imageCarousel/ResponsiveCarousel";

import { useEffect, useState } from "react";
import axios from "../../api/axios";

import "./home.scss";

const Home = () =>{
    const [images, setImages] = useState([]);
    const [reviews, setReviews] = useState([]);

    const [loadingImages, setLoadingImages] = useState(true);
    const [loadingReviews, setLoadingReviews] = useState(true);

    /** -------------------------------
     *  FETCH HOME IMAGES
     * ------------------------------- */
    useEffect(() => {
        const loadImages = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/images/home`);
                const data = await res.json();
                setImages(data);
            } catch (err) {
                console.error("Image load error:", err);
                setImages([]);
            }
            setLoadingImages(false);
        };

        loadImages();
    }, []);

    /** -------------------------------
     *  FETCH VERIFIED REVIEWS
     * ------------------------------- */
    useEffect(() => {
        const loadReviews = async () => {
            try {
                const res = await axios.get("/v/testimonials/verified");
                setReviews(res.data);
            } catch (err) {
                console.error("Review load error:", err);
                setReviews([]);
            }
            setLoadingReviews(false);
        };

        loadReviews();
    }, []);

    return (
        <div className="clientHome">
            <Greeting />

            {/* ---------------------- Fan Favourites Carousel ---------------------- */}
            <section className="favourites">
                <div className="heading">
                    <h1>Fan Favourites</h1>
                    <p>Our most famous flavours and dishes handpicked by our chefs.</p>
                </div>

                {loadingImages ? (
                    <p>Loading images...</p>
                ) : images.length > 0 ? (
                    <ResponsiveCarousel
                        images={images}
                        baseURL={process.env.REACT_APP_BASE_URL}
                    />
                ) : (
                    <p>No images available.</p>
                )}
            </section>

            {/* ---------------------- Testimonials ---------------------- */}
            <section className="review-carousel">
                <div className="review-heading dark">
                    <h1>What Our Customers Say</h1>
                    <p className="subheading">Real reviews from real customers</p>
                </div>

                {loadingReviews ? (
                    <p>Loading reviews...</p>
                ) : reviews.length > 0 ? (
                    <ReviewsCarousel reviews={reviews} />
                ) : (
                    <p>No reviews available.</p>
                )}
            </section>
        </div>
    );
}

export default Home;